import { scoreHeaderClass } from 'components/pages/PromoScorecard';
import React from 'react';
import { formatValue, formatWord } from 'utils/helperMethods';

interface Pops {
    allCheckedAttribute: any;
    listOfAttribute: any;
    title?: String;
}

function ShowSelection({ allCheckedAttribute, listOfAttribute, title = `Score for :` }: Pops) {
    return (
        <p className={`${scoreHeaderClass} flex`}>
            <span className="!w-[9vw] font-sm">{title}</span>
            <ShowSelectionInRow listOfAttribute={listOfAttribute} allCheckedAttribute={allCheckedAttribute} />
        </p>
    );
}

function ShowSelectionInRow({ listOfAttribute, allCheckedAttribute }: any) {
    return (
        <span className="flex gap-2 ml-1 flex-wrap">
            {listOfAttribute.map((attribute: any, key: any) => {
                if (!Object.keys(allCheckedAttribute?.[attribute] || {})?.length) {
                    return;
                }
                return (
                    <span className="font-sm">
                        {formatWord(attribute)} -{' '}
                        {allCheckedAttribute?.[attribute] && (
                            <span className="text-purpleFont font-medium">
                                {`${formatValue(Object.keys(allCheckedAttribute?.[attribute]), 1)} ${
                                    Object.keys(allCheckedAttribute?.[attribute]).length - 1
                                        ? `... +${Object.keys(allCheckedAttribute?.[attribute]).length - 1} more`
                                        : ''
                                }${listOfAttribute.length - 1 == key ? '' : ','}`}
                            </span>
                        )}
                    </span>
                );
            })}
        </span>
    );
}

export default ShowSelection;
